import { render } from "./ArchiveContactDialog.vue?vue&type=template&id=0d487180&scoped=true"
import script from "./ArchiveContactDialog.vue?vue&type=script&lang=js"
export * from "./ArchiveContactDialog.vue?vue&type=script&lang=js"

import "./ArchiveContactDialog.vue?vue&type=style&index=0&id=0d487180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d487180"]])

export default __exports__